import { downloadTextAsFile } from 'src/shared/helpers/downloadAsFile';
import type { ExportSiteManifestCSVRequest } from '../state/api/organisationEngineSlice';

export type TriggerExportSiteManifest = (request: ExportSiteManifestCSVRequest) => { unwrap: () => Promise<string> };

export const exportSiteManifest = async (triggerExport: TriggerExportSiteManifest, bcId: string): Promise<void> => {
    const csv = await triggerExport({ bcId }).unwrap();
    await downloadTextAsFile(csv, `site_manifest_${bcId}.csv`, { type: 'text/csv' });
};
